import Matter from "matter-js";
import { getPendantData } from ".";
import { MainProduct } from "../../types";
import { getMainProductVariantById } from "..";

const isChain = (label: string) => label.startsWith('chain/')

const CHAIN_CONSTRAINT_STIFFNESS = 0.96;
const CHAIN_CONSTRAINT_DAMPING = 0.22;

type Sprite = {
  width: number;
  height: number;
  constraintOffsetPoints: {
    left: Matter.Vector;
    right: Matter.Vector;
  };
}

const getChainPoint = (label: string, position: "right" | "left", sprites: Sprite[]) => {
  const spriteIndex = Number(label.split("/")[1])
  
  return sprites[spriteIndex].constraintOffsetPoints[position]
}

export const createNewConstraint = (
  bodyA: Matter.Body, 
  bodyB: Matter.Body, 
  mainProduct: MainProduct, 
  activeMainProductVariantId: string
) => {
  const bodyALabel = bodyA.label;
  const bodyBLabel = bodyB.label;

  const { pendantProducts } = mainProduct.metafields

  const mainProductVariantSprites = 
    getMainProductVariantById(mainProduct, activeMainProductVariantId)
      .metafields
      .builderData
      .sprites

  const isPointAIndentsChain = isChain(bodyALabel)
  const isPointBIndentsChain = isChain(bodyBLabel)

  const pointAIndents = isPointAIndentsChain
    ? getChainPoint(bodyALabel, 'left', mainProductVariantSprites) 
    : getPendantData(pendantProducts, bodyA.label.split('/')[1]).constraintOffsetPoints.right

  const pointBIndents = isPointBIndentsChain
    ? getChainPoint(bodyBLabel, 'right', mainProductVariantSprites) 
    : getPendantData(pendantProducts, bodyB.label.split('/')[1]).constraintOffsetPoints.left;

  const pointA = {
    x: pointAIndents.x * Math.cos(bodyA.angle) - pointAIndents.y * Math.sin(bodyA.angle),
    y: pointAIndents.x * Math.sin(bodyA.angle) - pointAIndents.y * Math.cos(bodyA.angle)
  }

  const pointB = {
    x: pointBIndents.x * Math.cos(bodyB.angle) - pointBIndents.y * Math.sin(bodyB.angle),
    y: pointBIndents.x * Math.sin(bodyB.angle) - pointBIndents.y * Math.cos(bodyB.angle)
  }

  return Matter.Constraint.create({
    bodyA,
    bodyB,
    pointA,
    pointB,
    length: 0,
    stiffness: CHAIN_CONSTRAINT_STIFFNESS,
    damping: CHAIN_CONSTRAINT_DAMPING,
    render: { visible: false }
  })
}